import { combineReducers } from 'redux';
import diags from './diags';
import session from './session'

export default combineReducers({
    diags, session
});